export default __webpack_public_path__ + "static/media/random-h-3.87da8091.jpg";